module.exports = {
  APP_ID: "124946",
  APP_KEY: "app_CIQcQCPybLHjsUJjDov19B6eofzPr9VKA5TN385xyrBevL6KrjEVy4lDpASH",
  APP_ENV: "sandbox",
  // API_URL: "http://localhost:3999",
  API_URL: "https://car-tags-api.goodideas-studio.com",
};
